class DynamicYieldEvents {

	constructor() {
		this.userNavSaleClick();
		this.shopthelookTriggerClick();
	}

	/**
	 * Event if shop the look trigger gets clicked.
	 */
	shopthelookTriggerClick() {
		document.addEventListener( 'click', ( ev ) => {
			const targetEl = ev.target.closest( '.shopthelook_button' );
			if ( targetEl ) {
				if ( 'undefined' !== typeof DY ) {
					window.DY.API( 'event',
						{
							name: 'SHOPTHELOOK_TRIGGER_CLICKED',
						},
					);
				}
			}
		} );
	}

	/**
	 * Event if sale user nav item gets clicked.
	 */
	userNavSaleClick() {
		document.addEventListener( 'click', ( ev ) => {
			const targetEl = ev.target.closest( '.mdl_header__user-nav-item--sale .mdl_header__user-nav-item-link' );
			if ( targetEl ) {
				if ( 'undefined' !== typeof DY ) {
					window.DY.API( 'event',
						{
							name: 'SALE_USER_NAV_CLICKED',
						},
					);
				}
			}
		} );
	}
}

const initDynamicYieldEvents = () => {
	window.SL_DY_EVENTS ??= new DynamicYieldEvents();
	return window.SL_DY_EVENTS;
}

export {
	DynamicYieldEvents as default,
	initDynamicYieldEvents
}
